import { Controller } from '@hotwired/stimulus';
import { revealEndOfCaseCompletionBannerIfNeeded } from '../../utils/case_experience/case_experience_in_rails';

export default class extends Controller {
  connect() {
    revealEndOfCaseCompletionBannerIfNeeded();
  }
}
